import dayjs from "dayjs";
import { BASE_URL } from "./Url";

export const magazineData = [
    {
        fileName: "magazine",
        filePath: "/Estetica_CN_84_Book_A_Digital_Version.pdf",
        cover: `/magazines/image-0.png`,
        name: "2024年10月号刊",
        _id: "2024年10月号刊",
        preview: 3
    },
    {
        fileName: "magazine",
        filePath: "/Estetica_CN_84_Book_A_Digital_Version.pdf",
        cover: `/magazines/image-1.png`,
        name: "2024年9月号刊",
        _id: "2024年9月号刊",
        preview: 3
    },
    {
        fileName: "magazine",
        filePath: "/Estetica_CN_84_Book_A_Digital_Version.pdf",
        cover: `/magazines/image-2.png`,
        name: "2024年8月号刊",
        _id: "2024年8月号刊",
        preview: 3
    },
    {
        fileName: "magazine",
        filePath: "/Estetica_CN_84_Book_A_Digital_Version.pdf",
        cover: `/magazines/image-3.png`,
        name: "2024年7月号刊",
        _id: "2024年7月号刊",
        preview: 3
    },
    {
        fileName: "magazine",
        filePath: "/Estetica_CN_84_Book_A_Digital_Version.pdf",
        cover: `/magazines/image-4.png`,
        name: "2024年6月号刊",
        _id: "2024年6月号刊",
        preview: 3
    },
    {
        fileName: "magazine",
        filePath: "/Estetica_CN_84_Book_A_Digital_Version.pdf",
        cover: `/magazines/image-5.png`,
        name: "2024年5月号刊",
        _id: "2024年5月号刊",
        preview: 3
    },
    {
        fileName: "magazine",
        filePath: "/Estetica_CN_84_Book_A_Digital_Version.pdf",
        cover: `/magazines/image-6.png`,
        name: "2024年4月号刊",
        _id: "2024年4月号刊",
        preview: 3
    },
    {
        fileName: "magazine",
        filePath: "/Estetica_CN_84_Book_A_Digital_Version.pdf",
        cover: `/magazines/image-7.png`,
        name: "2024年3月号刊",
        _id: "2024年3月号刊",
        preview: 3
    },
];


export const newsMainData = [
    {
        cover: "/news/image-0.png",
        name: "Kemon 时装秀：创新与激情点亮马德里"
    },
    {
        cover: "/news/image-1.png",
        name: "Freelance Re: Source – 可持续发展工具包，助力个体美发专业人士"
    },
    {
        cover: "/news/image-2.png",
        name: "如何制作这款由UNEC设计的华丽辫子发髻"
    }
];

export const schoolGalleryData = [
    {
        cover: "/about-us/Gallery.jpg",
    },
    {
        cover: "/about-us/Gallery1.jpg",
    },
    {
        cover: "/about-us/Gallery3.jpg",
    },
    {
        cover: "/about-us/Gallery.jpg",
    },
    {
        cover: "/about-us/Gallery1.jpg",
    },
    {
        cover: "/about-us/Gallery3.jpg",
    }
];

export const eventsData = [
    {
        title: 'អត្ថប្រយោជន៍នៃសូងខ្មែរ',
        // date: dayjs('Jan 25, 2024'),
        description: "សូងខ្មែរ គឺជាសំណង់សិប្បកម្មបុរាណមួយដែលមានតម្លៃខ្ពស់ជាសិល្បៈនិងវប្បធម៌។ វាមានអត្ថន័យជាច្រើនទាក់ទងទៅនឹងអត្តសញ្ញាណជាតិ ការអភិរក្សប្រពៃណី និងការលើកស្ទួយសេដ្ឋកិច្ចជាតិនៅកម្ពុជា។ អត្ថប្រយោជន៍សំខាន់ៗរបស់សូងខ្មែរមានដូចតទៅ៖\n\n១. អភិរក្សវប្បធម៌ និងអត្តសញ្ញាណជាតិ\nសូងខ្មែរ ជាប្រភេទសម្លៀកបំពាក់ប្រពៃណី ដែលបង្ហាញពីសិល្បៈនៃការត្បាញ និងការរចនាដែលមានសុភមង្គលន័យ។ ការស្លៀកសូងខ្មែរគឺជាវិធីមួយក្នុងការរក្សាទុក និងបន្តវប្បធម៌ខ្មែរអោយនៅដដែលនឹងមានតម្លៃសម្រាប់ជំនាន់ក្រោយ។\n\n២. លើកស្ទួយសេដ្ឋកិច្ចក្នុងសហគមន៍\nការផលិតសូងខ្មែរ ធ្វើឱ្យមានការបង្កើតការងារចំពោះស្ត្រីក្នុងជនបទ ជាពិសេសតំបន់ដែលមានប្រពៃណីត្បាញដូចជា បាត់ដំបង សៀមរាប ព្រៃវែង និងតាកែវ។ វាជួយបង្កើនប្រាក់ចំណូល និងលើកស្ទួយជីវភាពសេដ្ឋកិច្ចក្នុងសហគមន៍។\n\n៣. ជាសិល្បៈនិងភាពស្រស់ស្អាត\nសូងខ្មែរមានរចនាបថចម្រុះ និងពណ៌ស្រស់ស្អាត ដែលផ្ទុកនូវន័យនិងរឿងរ៉ាវប្រវត្តិសាស្រ្ត។ វាជាសម្លៀកបំពាក់ដែលបញ្ចេញភាពស្រស់ស្អាតនារីខ្មែរ និងបង្ហាញអំពីចំណាប់អារម្មណ៍ក្នុងសិល្បៈ។\n\n៤. ការប្រើប្រាស់ក្នុងពិធីប្រពៃណី និងសាសនា\nសូងខ្មែរ តែងត្រូវបានស្លៀកពាក់ក្នុងពិធីបុណ្យបុរាណដូចជា ពិធីបុណ្យចូលឆ្នាំខ្មែរ, ពិធីរៀបការ, ពិធីបុណ្យកាន់បិណ្ឌ និងពិធីសាសនាផ្សេងៗ។ វាបង្ហាញពីការគោរពនឹងទំនៀមទំលាប់ និងការរស់នៅបែបខ្មែរ។\n\n៥. ជាផលិតផលទេសចរណ៍\nសូងខ្មែរជាទំនិញសិប្បកម្មដែលភ្ញៀវទេសចរបរទេសចូលចិត្តទិញយកទៅជាអនុស្សាវរីយ៍។ វាជាសម្ភារៈដែលជួយផ្សព្វផ្សាយអំពីវប្បធម៌កម្ពុជា និងជួយស្រាវជ្រាវប្រាក់ចំណូលចូលក្នុងប្រទេស។",
        image: '/about-us/Event.jpg',
        code: "0001"
    },
    {
        title: 'ប្រភេទនៃសូងខ្មែរ',
        // date: dayjs('May 25, 2024'),
          "description": "សូងខ្មែរ គឺជាសំណង់សិប្បកម្មបុរាណមួយដែលមានតម្លៃខ្ពស់ជាសិល្បៈនិងវប្បធម៌។ វាមានអត្ថន័យជាច្រើនទាក់ទងទៅនឹងអត្តសញ្ញាណជាតិ ការអភិរក្សប្រពៃណី និងការលើកស្ទួយសេដ្ឋកិច្ចជាតិនៅកម្ពុជា។ អត្ថប្រយោជន៍សំខាន់ៗរបស់សូងខ្មែរមានដូចតទៅ៖\n\n១. អភិរក្សវប្បធម៌ និងអត្តសញ្ញាណជាតិ\nសូងខ្មែរ ជាប្រភេទសម្លៀកបំពាក់ប្រពៃណី ដែលបង្ហាញពីសិល្បៈនៃការត្បាញ និងការរចនាដែលមានសុភមង្គលន័យ។ ការស្លៀកសូងខ្មែរគឺជាវិធីមួយក្នុងការរក្សាទុក និងបន្តវប្បធម៌ខ្មែរអោយនៅដដែលនឹងមានតម្លៃសម្រាប់ជំនាន់ក្រោយ។\n\n២. លើកស្ទួយសេដ្ឋកិច្ចក្នុងសហគមន៍\nការផលិតសូងខ្មែរ ធ្វើឱ្យមានការបង្កើតការងារចំពោះស្ត្រីក្នុងជនបទ ជាពិសេសតំបន់ដែលមានប្រពៃណីត្បាញដូចជា បាត់ដំបង សៀមរាប ព្រៃវែង និងតាកែវ។ វាជួយបង្កើនប្រាក់ចំណូល និងលើកស្ទួយជីវភាពសេដ្ឋកិច្ចក្នុងសហគមន៍។\n\n៣. ជាសិល្បៈនិងភាពស្រស់ស្អាត\nសូងខ្មែរមានរចនាបថចម្រុះ និងពណ៌ស្រស់ស្អាត ដែលផ្ទុកនូវន័យនិងរឿងរ៉ាវប្រវត្តិសាស្រ្ត។ វាជាសម្លៀកបំពាក់ដែលបញ្ចេញភាពស្រស់ស្អាតនារីខ្មែរ និងបង្ហាញអំពីចំណាប់អារម្មណ៍ក្នុងសិល្បៈ។\n\n៤. ការប្រើប្រាស់ក្នុងពិធីប្រពៃណី និងសាសនា\nសូងខ្មែរ តែងត្រូវបានស្លៀកពាក់ក្នុងពិធីបុណ្យបុរាណដូចជា ពិធីបុណ្យចូលឆ្នាំខ្មែរ, ពិធីរៀបការ, ពិធីបុណ្យកាន់បិណ្ឌ និងពិធីសាសនាផ្សេងៗ។ វាបង្ហាញពីការគោរពនឹងទំនៀមទំលាប់ និងការរស់នៅបែបខ្មែរ។\n\n៥. ជាផលិតផលទេសចរណ៍\nសូងខ្មែរជាទំនិញសិប្បកម្មដែលភ្ញៀវទេសចរបរទេសចូលចិត្តទិញយកទៅជាអនុស្សាវរីយ៍។ វាជាសម្ភារៈដែលជួយផ្សព្វផ្សាយអំពីវប្បធម៌កម្ពុជា និងជួយស្រាវជ្រាវប្រាក់ចំណូលចូលក្នុងប្រទេស។\n\nប្រភេទនៃសូងខ្មែរ\nសូងខ្មែរមានច្រើនប្រភេទ ដែលខុសគ្នាទៅតាមតំបន់ ផ្នែករចនា វិធីត្បាញ និងរបៀបប្រើប្រាស់។ ប្រភេទសំខាន់ៗរួមមាន៖\n\n១. សូងព្រៃវែង\nទីតាំង៖ ខេត្តព្រៃវែង\nលក្ខណៈពិសេស៖ ត្រូវបានគេស្គាល់ថាជាសូងមានភាពសិប្បនិម្មិតខ្ពស់និងរចនាបថស្រស់ស្អាតជាមួយរូបរាងបុរាណ និងគំនូរទ្រង់ទ្រាយតូចៗជាច្រើន។\nប្រើប្រាស់៖ ពិធីបុណ្យ និងសារៈពិសេស\n\n២. សូងបូទន់\nទីតាំង៖ ខេត្តតាកែវ\nលក្ខណៈពិសេស៖ មានសំណាញ់លំអរច្រើនជាមួយពណ៌ស្ងប់ស្ងាត់ និងរចនាសាមញ្ញ តែមានសណ្ឋានស្អាត។\nប្រើប្រាស់៖ ស្លៀកនៅថ្ងៃសារៈសំខាន់ ឬអាចប្រើប្រចាំថ្ងៃ\n\n៣. សូងសំរោង\nទីតាំង៖ ខេត្តស្វាយរៀង\nលក្ខណៈពិសេស៖ រចនារូបផ្កា កែវកន្សោម និងគំនូរទេពភព ដោយមានពណ៌ចម្រុះជាច្រើន\nប្រើប្រាស់៖ ពិធីបុណ្យ និងរាំវង់ប្រពៃណី\n\n៤. សូងអង្គរ\nទីតាំង៖ ខេត្តសៀមរាប\nលក្ខណៈពិសេស៖ មានការរចនាដែលទាក់ទងនឹងរូបអង្គរ វត្ត និងបរិស្ថានបុរាណ\nប្រើប្រាស់៖ ពិធីដ៏សំខាន់ៗ ឬសម្រាប់បង្ហាញវប្បធម៌\n\n៥. សូងគីឡូ\nទីតាំង៖ ជាប់ព្រំដែនកម្ពុជា–ថៃ\nលក្ខណៈពិសេស៖ រចនាដោយសម្របសម្រួលជាមួយគំនូរ និងស្ទីលបែបសាសនាឥណ្ឌូ–ខ្មែរ\nប្រើប្រាស់៖ សម្រាប់ការចូលរួមពិធីសាសនា ឬសិល្បៈសម្ដែង\n\n៦. សូងសំបូរ\nទីតាំង៖ ខេត្តកំពង់ចាម\nលក្ខណៈពិសេស៖ រចនាដោយដៃយ៉ាងម៉ត់ចត់ មានខ្សែច្រវាក់គំនូររដ្ធថ្ម និងរូបសត្វបុរាណ\nប្រើប្រាស់៖ ពិធីជប់លៀង សិល្បៈឬពិធីជ្រមុជ",
        image: '/about-us/Event1.jpg',
        code: "0002"
    },
    {
        title: 'ការស្លៀកសូងខ្មែរ',
        date: dayjs('Mar 25, 2024'),
        description: 'ការស្លៀកសូងខ្មែរ មិនត្រឹមជាការចងចាំអតីតកាលទេ ប៉ុន្តែជាការស្ដារឡើងវិញនូវមនោសញ្ចេតនានិងការគោរពចំពោះដំណើរវប្បធម៌របស់ជាតិខ្មែរ។ យើងគួរតែមានមនោសញ្ចេតនាអំពីសារៈសំខាន់នៃសូងខ្មែរ និងរួមចំណែកក្នុងការផ្សព្វផ្សាយវប្បធម៌ខ្មែរអោយកាន់តែទូលំទូលាយទៅសកលលោក។',
        image: '/about-us/Event2.jpg',
        code: "0003"
    },
];

export const noticeData = [
    {
        title: 'Blood Donation Day 2024.',
        date: dayjs('Jan 25, 2024'),
        description: 'If you overlap your hobby and learning English, then you can be curious what do you call these sport terms in English. This would help to read the world sport news in the original without difficulty, communicate with your foreign peers, and understand English-speaking sports commentators. It is easy to remember the names of principal athletic disciplines in English. The most of the words adopted by the Russian language in their original phonetic form represent a linguistic calque. For example, football, basketball, volleyball, tennis. There are, however, certain linguistic features in the names of plays or areas that are specific to the spoken language of Brits, Canadians, Americans, Australians, and people of other English-speaking countries. The popularity of a particular discipline and its name variant also depend on the country (there are exclusively British and American sports). In the US, football is mostly called soccer, while in the UK the name is football. The sports that are loved in the UK are handball (гандбол), fencing (фехтование), cricket (крикет), chess (шахматы), rowing (гребля), golf (гольф), etc. Let us learn what are the names of various sports in English and their translation. Now, as you have familiarized with the primary sports terms, you can make exercises to remember them and have more practice. If you want to learn the English language in depth with fun and communicate on various specific topics, CIS International School can help you with that. Call us 012365874953 and learn more about the application procedure, programs offered by the School, and the prospects of success that the students of the School would have in life. British CIS representative offices and School campuses are based in Moscow, Saint Petersburg, and Tashkent.',
        code: "0001"
    },
    {
        title: 'Reunions 2024 , batch 75.',
        date: dayjs('May 25, 2024'),
        description: "The most of the words adopted by the Russian language in their original phonetic form represent a linguistic calque. For example, football, basketball, volleyball, tennis. There are, however, certain linguistic features in the names of plays or areas that are specific to the spoken language of Brits, Canadians, Americans, Australians, and people of other English-speaking countries. The popularity of a particular discipline and its name variant also depend on the country (there are exclusively British and American sports). In the US, football is mostly called soccer, while in the UK the name is football. The sports that are loved in the UK are handball (гандбол), fencing (фехтование), cricket (крикет), chess (шахматы), rowing (гребля), golf (гольф), etc. Let us learn what are the names of various sports in English and their translation. Now, as you have familiarized with the primary sports terms, you can make exercises to remember them and have more practice. If you want to learn the English language in depth with fun and communicate on various specific topics, CIS International School can help you with that. Call us 012365874953 and learn more about the application procedure, programs offered by the School, and the prospects of success that the students of the School would have in life. British CIS representative offices and School campuses are based in Moscow, Saint Petersburg, and Tashkent.",
        code: "0002"
    },
    {
        title: 'Past Pupil Reunions',
        date: dayjs('Mar 25, 2024'),
        description: "An amateur player, or a sport geek, than you surely are familiar with the sport language. And if you overlap your hobby and learning English, then you can be curious what do you call these sport terms in English. This would help to read the world sport news in the original without difficulty, communicate with your foreign peers, and understand English-speaking sports commentators. It is easy to remember the names of principal athletic disciplines in English. The most of the words adopted by the Russian language in their original phonetic form represent a linguistic calque. For example, football, basketball, volleyball, tennis. There are, however, certain linguistic features in the names of plays or areas that are specific to the spoken language of Brits, Canadians, Americans, Australians, and people of other English-speaking countries. The popularity of a particular discipline and its name variant also depend on the country (there are exclusively British and American sports). In the US, football is mostly called soccer, while in the UK the name is football. The sports that are loved in the UK are handball (гандбол), fencing (фехтование), cricket (крикет), chess (шахматы), rowing (гребля), golf (гольф), etc. Let us learn what are the names of various sports in English and their translation. Now, as you have familiarized with the primary sports terms, you can make exercises to remember them and have more practice. If you want to learn the English language in depth with fun and communicate on various specific topics, CIS International School can help you with that. Call us 012365874953 and learn more about the application procedure, programs offered by the School, and the prospects of success that the students of the School would have in life. British CIS representative offices and School campuses are based in Moscow, Saint Petersburg, and Tashkent.",
        code: "0003"
    },
    {
        title: 'First Semester Exam',
        date: dayjs('Jan 25, 2024'),
        description: "You surely are familiar with the sport language. And if you overlap your hobby and learning English, then you can be curious what do you call these sport terms in English. This would help to read the world sport news in the original without difficulty, communicate with your foreign peers, and understand English-speaking sports commentators. It is easy to remember the names of principal athletic disciplines in English. The most of the words adopted by the Russian language in their original phonetic form represent a linguistic calque. For example, football, basketball, volleyball, tennis. There are, however, certain linguistic features in the names of plays or areas that are specific to the spoken language of Brits, Canadians, Americans, Australians, and people of other English-speaking countries. The popularity of a particular discipline and its name variant also depend on the country (there are exclusively British and American sports). In the US, football is mostly called soccer, while in the UK the name is football. The sports that are loved in the UK are handball (гандбол), fencing (фехтование), cricket (крикет), chess (шахматы), rowing (гребля), golf (гольф), etc. Let us learn what are the names of various sports in English and their translation. Now, as you have familiarized with the primary sports terms, you can make exercises to remember them and have more practice. If you want to learn the English language in depth with fun and communicate on various specific topics, CIS International School can help you with that. Call us 012365874953 and learn more about the application procedure, programs offered by the School, and the prospects of success that the students of the School would have in life. British CIS representative offices and School campuses are based in Moscow, Saint Petersburg, and Tashkent.",
        code: "0004"
    },
    {
        title: 'Annual Sports Day',
        date: dayjs('May 25, 2024'),
        description: "If you are a dedicated athlete, an amateur player, or a sport geek, than you surely are familiar with the sport language. And if you overlap your hobby and learning English, then you can be curious what do you call these sport terms in English. This would help to read the world sport news in the original without difficulty, communicate with your foreign peers, and understand English-speaking sports commentators. It is easy to remember the names of principal athletic disciplines in English. The most of the words adopted by the Russian language in their original phonetic form represent a linguistic calque. For example, football, basketball, volleyball, tennis. There are, however, certain linguistic features in the names of plays or areas that are specific to the spoken language of Brits, Canadians, Americans, Australians, and people of other English-speaking countries. The popularity of a particular discipline and its name variant also depend on the country (there are exclusively British and American sports). In the US, football is mostly called soccer, while in the UK the name is football. The sports that are loved in the UK are handball (гандбол), fencing (фехтование), cricket (крикет), chess (шахматы), rowing (гребля), golf (гольф), etc. Let us learn what are the names of various sports in English and their translation. Now, as you have familiarized with the primary sports terms, you can make exercises to remember them and have more practice. If you want to learn the English language in depth with fun and communicate on various specific topics, CIS International School can help you with that. Call us 012365874953 and learn more about the application procedure, programs offered by the School, and the prospects of success that the students of the School would have in life. British CIS representative offices and School campuses are based in Moscow, Saint Petersburg, and Tashkent.",
        code: "0005"
    },
    {
        title: 'Second Semester Exam',
        date: dayjs('Mar 25, 2024'),
        description: "Dedicated athlete, an amateur player, or a sport geek, than you surely are familiar with the sport language. And if you overlap your hobby and learning English, then you can be curious what do you call these sport terms in English. This would help to read the world sport news in the original without difficulty, communicate with your foreign peers, and understand English-speaking sports commentators. It is easy to remember the names of principal athletic disciplines in English. The most of the words adopted by the Russian language in their original phonetic form represent a linguistic calque. For example, football, basketball, volleyball, tennis. There are, however, certain linguistic features in the names of plays or areas that are specific to the spoken language of Brits, Canadians, Americans, Australians, and people of other English-speaking countries. The popularity of a particular discipline and its name variant also depend on the country (there are exclusively British and American sports). In the US, football is mostly called soccer, while in the UK the name is football. The sports that are loved in the UK are handball (гандбол), fencing (фехтование), cricket (крикет), chess (шахматы), rowing (гребля), golf (гольф), etc. Let us learn what are the names of various sports in English and their translation. Now, as you have familiarized with the primary sports terms, you can make exercises to remember them and have more practice. If you want to learn the English language in depth with fun and communicate on various specific topics, CIS International School can help you with that. Call us 012365874953 and learn more about the application procedure, programs offered by the School, and the prospects of success that the students of the School would have in life. British CIS representative offices and School campuses are based in Moscow, Saint Petersburg, and Tashkent.",
        code: "0006"
    },
];


export const newsData = [
    {
        code: "00001",
        cover: "/news/image-3.jpg",
        video: "/videos/blog.mp4",
        title: "ស៊ឹងខ្មែរប្រណិតសាច់ស្អាតផលិតផលខ្មែរតម្បាញដោយដៃខ្មែរ",
        description: "បងស្រី ជា Fan ស៊ឹងខ្មែរ , ម៉ូតដែលគាត់កំពុងប្រើជាស៊ឹងខ្មែរ មានច្រើនម៉ូត ហើយពណ៌ និង ម៉ូតផ្សេងៗគ្នាបងៗដែលស្រលាញ់ផលិតផលខ្មែរបងៗប្រាកដជាយល់អារម្មណ៍មួយនេះ ស្រលាញ់ួទើបជួយគាំទ្រ. សូមអរគុណបងស្រីនូវទឹកចិត្តមួយនេះចេញពីបេះដូងពិតៗ ដែលតែងតែជួយគំាទ្រស៊ឹងខ្មែរ ដូចខ្ញុំធ្លាប់លើកឡើង (( មួយសំពត់ ជួយបានមួយគ្រួសារខ្មែរ )). ខ្មែរស្រលាញ់គ្នា ខ្មែរចេះគាំទ្រគ្នា ទើបខ្មែរយើងរីកចំរើន",
        company: "View Blog",
        publishedDate: dayjs("Mar 25, 2024"),
    },
    {
        code: "00002",
        cover: "/news/image-4.jpg",
        video: "/videos/blog1.mp4",
        title: "បទសម្ភាសរវាងនាងខ្ញុំម្ចាស់ហាង ស្រីមឿនស៊ឹងខ្មែរ ជាមួយនឹងទូរទស្សន៍ប៉ុសលេខ៥",
        description: "បទសម្ភាសរវាងនាងខ្ញុំម្ចាស់ហាង ស្រីមឿនស៊ឹងខ្មែរ ជាមួយនឹងទូរទស្សន៍ប៉ុសលេខ៥ និយាយអំពី ជួយដល់ស្ត្រីអ្នកតម្បាញឲបានកាន់តែច្រើន និង ផ្សព្វផ្សាយវិស័យតម្បាញកម្ពុជាយើងឲកាន់តែទូលំទូលាយ នាងខ្ញុំជួយយកផលិតផលខ្មែរ ជួយផ្សព្វផ្សាយ និង ជួយបង្កើតការងារ ដូច្នោះមានតែបងៗប៉ុណ្ណោះដែលជាកត្តារុញច្រានឲវិស័យមួយនេះកាន់តែទូលំទូលាយ មានទីផ្សារ មានសន្ទុះ និង មានភាពរីកចំរើន. ជួយផ្សព្វផ្សាយស្នាដៃ វប្បធម៌ខ្មែរ ជួយលើកស្ទួយវិស័យតម្បាញ និង បង្កើតកាងារដល់អ្នកតម្បាញកម្ពុជា.",
        company: "View Blog",
        publishedDate: dayjs("Mar 25, 2024"),
    },
    {
        code: "00003",
        cover: "/news/image-5.jpg",
        video: "/videos/blog2.mp4",
        title: "សុឹងខ្មែរVIPសាច់អំបោះសុតលេខ១បោកទឹកបានផលិតផលខ្មែរធ្វើដោយដៃ",
        description: "សុឹងខ្មែរ VIP នេះត្រូវបានបំផុសឡើងដោយសាច់អំបោះសុទ្ធខ្ពស់បំផុត លេខ ១ មានគុណភាពល្អ ទន់និងត្រជាក់ប៉ះលើស្បែក បោកទឹកបានមិនខូចទ្រនាប់ពណ៌។ ត្រូវបានផលិតដោយកូនខ្មែរដៃទទួលបណ្ដុះបណ្ដាលពីបុរាណ ប្រើក្រមែងដើមភាគក្នុងស្រុក ដើម្បីរក្សាទុកសិល្បៈនិងវប្បធម៌ជាតិ។ មានសមត្ថភាពសម្រាប់ពាក់ពេលចូលរួមពិធីជប់លៀង ពិធីបុណ្យផ្សេងៗ ឬប្រើជាថេនតុបតែងនៅក្នុងគេហដ្ឋាន។",
        company: "View Blog",
        publishedDate: dayjs("Nov 23, 2021"),
    },
    {
        code: "00004",
        cover: "/news/image-6.jpg",
        video: "/videos/blog3.mp4",
        title: "ស៊ឹងខ្មែរផលិតផលខ្មែរ តម្បាញដោយដៃ សាច់អំបោះសុត បោកទឹកបានសូមជួយគាំទ្រផលិតផលខ្មែរទាំងអស់គ្នា",
        description: "សុឹងខ្មែរ VIP សាច់អំបោះសុទ្ធ ចូលស្តុកថ្មី – រចនាថ្មី ស្អាតបែបប្រពៃណី បោកទឹកបាន សុឹងខ្មែរ VIP ចូលស្តុកថ្មីទៀតហើយ! ផលិតផលថ្មីៗ មានរចនាលំនាំស្អាតប្លែកភ្នែក បងប្អូនអាចជ្រើសរើសបានយ៉ាងច្រើនប្រភេទ។ ធ្វើពី សាច់អំបោះសុទ្ធ ១០០% មានគុណភាពខ្ពស់ ទន់ មិនខ្សោយ ពណ៌ស្អាតបែបធម្មជាតិ បោកទឹកបានដោយមិនខូចទ្រនាប់។ 🧵 ផលិតដោយដៃ ដោយសិប្បករខ្មែរ ដែលមានជំនាញជាន់ខ្ពស់ 🇰🇭 ផលិតផលជាតិ – រក្សាសិល្បៈខ្មែរបែបបុរាណ 🎨 រចនាថ្មីៗ – ទាន់សម័យ បែបប្រពៃណី ប៉ុន្តែសម័យថ្មី 💧 គុណភាពអាចបោកទឹកបាន ពណ៌មិនច្រេះ មិនប៉ះស្បែក សាកសមសម្រាប់ពាក់ក្នុងពិធីបុណ្យ បុណ្យចូលឆ្នាំជាតិ បុណ្យភ្ជុំបិណ្ឌ ឬពាក់ប្រចាំថ្ងៃជាមួយសម្លៀកបំពាក់ទាន់សម័យផ្សេងៗ។",
        company: "View Blog",
        publishedDate: dayjs("Nov 23, 2021"),
    },
];


export const educationData = [
    {
        videoUrl: "example.com",
        title: "如何制作这款由UNEC设计的华丽辫子发髻",
        description: "UNEC (全国美发企业联盟) 一步步重现了这一华丽的编织发髻，并将其命名为 Fascination。",
        imageUrl: "/education/image-0.png",
    },
    {
        videoUrl: "",
        title: "如何制作这款由UNEC设计的华丽辫子发髻",
        description: "UNEC (全国美发企业联盟) 一步步重现了这一华丽的编织发髻，并将其命名为 Fascination。",
        imageUrl: "/education/image-1.png",
    },
    {
        videoUrl: "example.com",
        title: "如何制作这款由UNEC设计的华丽辫子发髻",
        description: "UNEC (全国美发企业联盟) 一步步重现了这一华丽的编织发髻，并将其命名为 Fascination。",
        imageUrl: "/education/image-2.png",
    },
    {
        videoUrl: "",
        title: "如何制作这款由UNEC设计的华丽辫子发髻",
        description: "UNEC (全国美发企业联盟) 一步步重现了这一华丽的编织发髻，并将其命名为 Fascination。",
        imageUrl: "/education/image-3.png",
    },
    {
        videoUrl: "example.com",
        title: "如何制作这款由UNEC设计的华丽辫子发髻",
        description: "UNEC (全国美发企业联盟) 一步步重现了这一华丽的编织发髻，并将其命名为 Fascination。",
        imageUrl: "/education/image-4.png",
    },
    {
        videoUrl: "",
        title: "如何制作这款由UNEC设计的华丽辫子发髻",
        description: "UNEC (全国美发企业联盟) 一步步重现了这一华丽的编织发髻，并将其命名为 Fascination。",
        imageUrl: "/education/image-5.png",
    },
    {
        videoUrl: "",
        title: "如何制作这款由UNEC设计的华丽辫子发髻",
        description: "UNEC (全国美发企业联盟) 一步步重现了这一华丽的编织发髻，并将其命名为 Fascination。",
        imageUrl: "/education/image-6.png",
    },
    {
        videoUrl: "",
        title: "如何制作这款由UNEC设计的华丽辫子发髻",
        description: "UNEC (全国美发企业联盟) 一步步重现了这一华丽的编织发髻，并将其命名为 Fascination。",
        imageUrl: "/education/image-7.png",
    },
    {
        videoUrl: "",
        title: "如何制作这款由UNEC设计的华丽辫子发髻",
        description: "UNEC (全国美发企业联盟) 一步步重现了这一华丽的编织发髻，并将其命名为 Fascination。",
        imageUrl: "/education/image-8.png",
    }
];

export const productsData = [
    {
        code: "0001",
        title: 'Cotton Scarf Handmade...',
        image: [
            `${BASE_URL + "/about-us/bestSeller.jpg"}`,
            `${BASE_URL}/about-us/soeungKontoisKaneav1.jpg`,
            `${BASE_URL}/about-us/soeungKontoisKaneav2.jpg`,
        ],
        // originalPrice: 100.00,
        // salePrice: 98.00,
        description: ""
    },
    {
        code: "0002",
        title: 'Cotton Scarf',
        image: [
            `${BASE_URL + "/about-us/bestSeller1.jpg"}`,
            `${BASE_URL}/about-us/soeungKontoisKaneav1.jpg`,
            `${BASE_URL}/about-us/soeungKontoisKaneav2.jpg`,
        ],
        // originalPrice: 100.00,
        // salePrice: 98.00,
        description: ""
    },
    {
        code: "0003",
        title: 'Cotton Scarf Handmade...',
        image: [
            `${BASE_URL + "/about-us/bestSeller2.jpg"}`,
            `${BASE_URL}/about-us/soeungKontoisKaneav1.jpg`,
            `${BASE_URL}/about-us/soeungKontoisKaneav2.jpg`,
        ],
        // originalPrice: 100.00,
        // salePrice: 98.00,
        description: ""
    },
    {
        code: "0004",
        title: 'Cotton Scarf',
        image: [
            `${BASE_URL + "/about-us/bestSeller3.jpg"}`,
            `${BASE_URL}/about-us/soeungKontoisKaneav1.jpg`,
            `${BASE_URL}/about-us/soeungKontoisKaneav2.jpg`,
        ],
        // originalPrice: 100.00,
        // salePrice: 98.00,
        description: ""
    },
    {
        code: "0005",
        title: 'Cotton Scarf Handmade...',
        image: [
            `${BASE_URL + "/about-us/SeoungHangVIP.jpg"}`,
            `${BASE_URL}/about-us/soeungKontoisKaneav1.jpg`,
            `${BASE_URL}/about-us/soeungKontoisKaneav2.jpg`,
        ],
        // originalPrice: 100.00,
        // salePrice: 98.00,
        description: ""
    },
    {
        code: "0006",
        title: 'Cotton Scarf',
        image: [
            `${BASE_URL + "/about-us/SeoungHangVIP1.jpg"}`,
            `${BASE_URL}/about-us/soeungKontoisKaneav1.jpg`,
            `${BASE_URL}/about-us/soeungKontoisKaneav2.jpg`,
        ],
        // originalPrice: 100.00,
        // salePrice: 98.00,
        description: ""
    },
    {
        code: "0007",
        title: 'Cotton Scarf Handmade...',
        image: [
            `${BASE_URL + "/about-us/SeoungHangVIP2.jpg"}`,
            `${BASE_URL}/about-us/soeungKontoisKaneav1.jpg`,
            `${BASE_URL}/about-us/soeungKontoisKaneav2.jpg`,
        ],
        // originalPrice: 100.00,
        // salePrice: 98.00,
        description: ""
    },
    {
        code: "0008",
        title: 'Cotton Scarf',
        image: [
            `${BASE_URL + "/about-us/SeoungHangVIP3.jpg"}`,
            `${BASE_URL}/about-us/soeungKontoisKaneav1.jpg`,
            `${BASE_URL}/about-us/soeungKontoisKaneav2.jpg`,
        ],
        // originalPrice: 100.00,
        // salePrice: 98.00,
        description: ""
    },
    {
        code: "0009",
        title: 'Cotton Scarf Handmade...',
        image: [
            `${BASE_URL + "/about-us/SoeungChorCherngthom.jpg"}`,
            `${BASE_URL}/about-us/soeungKontoisKaneav1.jpg`,
            `${BASE_URL}/about-us/soeungKontoisKaneav2.jpg`,
        ],
        // originalPrice: 100.00,
        // salePrice: 98.00,
        description: ""
    },
    {
        code: "0010",
        title: 'Cotton Scarf',
        image: [
            `${BASE_URL + "/about-us/SoeungChorCherngthom1.jpg"}`,
            `${BASE_URL}/about-us/soeungKontoisKaneav1.jpg`,
            `${BASE_URL}/about-us/soeungKontoisKaneav2.jpg`,
        ],
        // originalPrice: 100.00,
        // salePrice: 98.00,
        description: ""
    },
    {
        code: "00011",
        title: 'Cotton Scarf Handmade...',
        image: [
            `${BASE_URL + "/about-us/SoeungChorCherngthom2.jpg"}`,
            `${BASE_URL}/about-us/soeungKontoisKaneav1.jpg`,
            `${BASE_URL}/about-us/soeungKontoisKaneav2.jpg`,
        ],
        // originalPrice: 100.00,
        // salePrice: 98.00,
        description: ""
    },
    {
        code: "00012",
        title: 'Cotton Scarf',
        image: [
            `${BASE_URL + "/about-us/SoeungChorCherngthom3.jpg"}`,
            `${BASE_URL}/about-us/soeungKontoisKaneav1.jpg`,
            `${BASE_URL}/about-us/soeungKontoisKaneav2.jpg`,
        ],
        // originalPrice: 100.00,
        // salePrice: 98.00,
        description: ""
    },
    {
        code: "00013",
        title: 'Cotton Scarf Handmade...',
        image: [
            `${BASE_URL + "/about-us/soeungKontoisKaneav.jpg"}`,
            `${BASE_URL}/about-us/soeungKontoisKaneav1.jpg`,
            `${BASE_URL}/about-us/soeungKontoisKaneav2.jpg`,
        ],
        // originalPrice: 100.00,
        // salePrice: 98.00,
        description: ""
    },
    {
        code: "00014",
        title: 'Cotton Scarf',
        image: [
            `${BASE_URL + "/about-us/soeungKontoisKaneav1.jpg"}`,
            `${BASE_URL}/about-us/soeungKontoisKaneav1.jpg`,
            `${BASE_URL}/about-us/soeungKontoisKaneav2.jpg`,
        ],
        // originalPrice: 100.00,
        // salePrice: 98.00,
        description: ""
    },
    {
        code: "00015",
        title: 'Cotton Scarf Handmade...',
        image: [
            `${BASE_URL + "/about-us/soeungKontoisKaneav2.jpg"}`,
            `${BASE_URL}/about-us/soeungKontoisKaneav1.jpg`,
            `${BASE_URL}/about-us/soeungKontoisKaneav2.jpg`,
        ],
        // originalPrice: 100.00,
        // salePrice: 98.00,
        description: ""
    },
    {
        code: "00016",
        title: 'Cotton Scarf',
        image: [
            `${BASE_URL + "/about-us/soeungKontoisKaneav3.jpg"}`,
            `${BASE_URL}/about-us/soeungKontoisKaneav1.jpg`,
            `${BASE_URL}/about-us/soeungKontoisKaneav2.jpg`,
        ],
        // originalPrice: 100.00,
        // salePrice: 98.00
    },
    // Add more products...
];

export const productsHomeData = [
    // សុឹងខ្មែរ ជជើងតូច
    {
        code: "0001",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងតូច',
        image: [
            `${BASE_URL}/soeungkhmersmall/soeungkhmersmall.jpg`,
            `${BASE_URL}/soeungkhmersmall/soeungkhmersmall1.jpg`,
            `${BASE_URL}/soeungkhmersmall/soeungkhmersmall2.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងតូច",
    },
    {
        code: "0002",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងតូច',
        image: [
            `${BASE_URL}/soeungkhmersmall/soeungkhmersmall2.jpg`,
            `${BASE_URL}/soeungkhmersmall/soeungkhmersmall4.jpg`,
            `${BASE_URL}/soeungkhmersmall/soeungkhmersmall5.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងតូច",
    },
    {
        code: "0003",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងតូច',
        image: [
            `${BASE_URL}/soeungkhmersmall/soeungkhmersmall3.jpg`,
            `${BASE_URL}/soeungkhmersmall/soeungkhmersmall6.jpg`,
            `${BASE_URL}/soeungkhmersmall/soeungkhmersmall4.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងតូច",
    },
    {
        code: "0004",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងតូច',
        image: [
            `${BASE_URL}/soeungkhmersmall/soeungkhmersmall4.jpg`,
            `${BASE_URL}/soeungkhmersmall/soeungkhmersmall6.jpg`,
            `${BASE_URL}/soeungkhmersmall/soeungkhmersmall2.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងតូច",
    },
    {
        code: "0005",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងតូច',
        image: [
            `${BASE_URL}/soeungkhmersmall/soeungkhmersmall5.jpg`,
            `${BASE_URL}/soeungkhmersmall/soeungkhmersmall6.jpg`,
            `${BASE_URL}/soeungkhmersmall/soeungkhmersmall2.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងតូច",
    },
    {
        code: "0005",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងតូច',
        image: [
            `${BASE_URL}/soeungkhmersmall/soeungkhmersmall6.jpg`,
            `${BASE_URL}/soeungkhmersmall/soeungkhmersmall1.jpg`,
            `${BASE_URL}/soeungkhmersmall/soeungkhmersmall2.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងតូច",
    },
    {
        code: "0005",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងតូច',
        image: [
            `${BASE_URL}/soeungkhmersmall/soeungkhmersmall1.jpg`,
            `${BASE_URL}/soeungkhmersmall/soeungkhmersmall3.jpg`,
            `${BASE_URL}/soeungkhmersmall/soeungkhmersmall2.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងតូច",
    },

    // សុឹងខ្មែរ ជជើងធំ
    // {
    //     code: "0005",
    //     title: 'ក្រណាត់សុឹងខ្មែរ ជជើងធំ',
    //     image: [
    //         `${BASE_URL}/soeungkhmersmall/soeungkhmersmall1.jpg`,
    //         `${BASE_URL}/soeungkhmersmall/soeungkhmersmall3.jpg`,
    //         `${BASE_URL}/soeungkhmersmall/soeungkhmersmall2.jpg`,
    //     ],
    //     category:"សុឹងខ្មែរ ជជើងធំ",
    // },

    // សុឹងខ្មែរ ជជើងប្រណិត
    {
        code: "0001",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury1.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury-9.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury-8.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0002",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury2.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury-9.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury-8.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0003",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury3.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury-8.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury-7.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0004",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury4.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury-7.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury-6.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0005",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury5.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury-6.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury-5.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0006",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury6.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury-5.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury-4.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0007",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury7.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury-4.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury-3.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0008",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury8.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury-3.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury-2.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0009",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury9.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury-2.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury-1.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0010",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury10.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury-1.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury0.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0011",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury11.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury0.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury1.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0012",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury12.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury1.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury2.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0013",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury13.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury2.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury3.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0014",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury14.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury3.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury4.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0015",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury15.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury4.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury5.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0016",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury16.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury5.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury6.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0017",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury17.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury6.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury7.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0018",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury18.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury7.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury8.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0019",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury19.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury8.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury9.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0020",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury20.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury9.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury10.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0021",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury21.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury10.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury11.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0022",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury22.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury11.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury12.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0023",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury23.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury12.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury13.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0024",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury24.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury13.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury14.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0025",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury25.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury14.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury15.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0026",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury26.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury15.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury16.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0027",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury27.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury16.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury17.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0028",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury28.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury17.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury18.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0029",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury29.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury18.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury19.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0030",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury30.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury19.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury20.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0031",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury31.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury20.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury21.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0032",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury32.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury21.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury22.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0033",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury33.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury22.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury23.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0034",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury34.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury23.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury24.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0035",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury35.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury24.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury25.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0036",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury36.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury25.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury26.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0037",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury37.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury26.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury27.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0038",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury38.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury27.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury28.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0039",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury39.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury28.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury29.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0040",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury40.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury29.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury30.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0041",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury41.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury30.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury31.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0042",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury42.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury31.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury32.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0043",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury43.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury32.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury33.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0044",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury44.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury33.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury34.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0045",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury45.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury34.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury35.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0046",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury46.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury35.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury36.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0047",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury47.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury36.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury37.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0048",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury48.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury37.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury38.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0049",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury49.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury38.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury39.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0050",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury50.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury39.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury40.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0051",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury51.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury40.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury41.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0052",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury52.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury41.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury42.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0053",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury53.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury42.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury43.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0054",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury54.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury43.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury44.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0055",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury55.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury44.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury45.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0056",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury56.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury45.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury46.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0057",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury57.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury46.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury47.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0058",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury58.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury47.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury48.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0059",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury59.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury48.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury49.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0060",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury60.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury49.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury50.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0061",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury61.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury50.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury51.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0062",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury62.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury51.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury52.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0063",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury63.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury52.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury53.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0064",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury64.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury53.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury54.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0065",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury65.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury54.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury55.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0066",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury66.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury55.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury56.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0067",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury67.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury56.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury57.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0068",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury68.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury57.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury58.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0069",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury69.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury58.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury59.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0070",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury70.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury59.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury60.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0071",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury71.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury60.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury61.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0072",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury72.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury61.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury62.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0073",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury73.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury62.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury63.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0074",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury74.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury63.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury64.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0075",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury75.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury64.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury65.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0076",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury76.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury65.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury66.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0077",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury77.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury66.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury67.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0078",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury78.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury67.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury68.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0079",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury79.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury68.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury69.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0080",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury80.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury69.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury70.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0081",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury81.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury70.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury71.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0082",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury82.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury71.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury72.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0083",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury83.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury72.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury73.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0084",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury84.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury73.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury74.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0085",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury85.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury74.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury75.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0086",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury86.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury75.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury76.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0087",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury87.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury76.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury77.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0088",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury88.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury77.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury78.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0089",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury89.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury78.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury79.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0090",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury90.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury79.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury80.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0091",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury91.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury80.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury81.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0092",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury92.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury81.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury82.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0093",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury93.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury82.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury83.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0094",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury94.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury83.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury84.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0095",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury95.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury84.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury85.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0096",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury96.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury85.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury86.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0097",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury97.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury86.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury87.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0098",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury98.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury87.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury88.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0099",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury99.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury88.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury89.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },
    {
        code: "0100",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងប្រណិត',
        image: [
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury100.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury89.jpg`,
            `${BASE_URL}/soeungkhmerluxury/soeungkhmerluxury90.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងប្រណិត"
    },

    // សុឹងខ្មែរ ជជើងVIP
    {
        code: "01",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP1.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP2.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP8.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "02",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP2.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP3.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP9.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "03",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP3.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP4.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP10.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "04",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP4.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP5.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP11.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "05",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP5.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP6.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP12.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "06",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP6.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP7.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP13.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "07",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP7.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP8.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP14.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "08",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP8.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP9.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP15.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "09",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP9.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP10.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP16.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "10",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP10.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP11.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP17.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "11",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP11.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP12.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP18.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "12",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP12.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP13.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP19.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "13",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP13.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP14.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP20.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "14",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP14.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP15.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP21.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "15",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP15.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP16.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP22.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "16",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP16.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP17.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP23.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "17",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP17.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP18.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP24.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "18",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP18.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP19.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP25.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "19",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP19.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP20.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP26.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "20",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP20.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP21.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP27.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "21",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP21.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP22.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP28.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "22",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP22.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP23.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP29.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "23",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP23.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP24.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP30.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "24",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP24.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP25.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP31.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "25",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP25.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP26.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP32.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "26",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP26.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP27.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP33.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "27",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP27.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP28.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP34.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "28",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP28.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP29.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP35.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "29",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP29.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP30.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP36.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "30",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP30.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP31.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP37.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "31",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP31.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP32.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP38.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "32",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP32.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP33.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP39.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "33",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP33.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP34.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP40.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "34",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP34.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP35.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP41.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "35",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP35.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP36.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP42.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "36",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP36.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP37.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP43.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "37",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP37.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP38.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP44.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "38",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP38.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP39.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP45.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "39",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP39.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP40.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP46.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "40",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP40.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP41.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP47.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "41",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP41.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP42.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP48.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "42",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP42.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP43.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP49.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "43",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP43.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP44.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP50.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "44",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP44.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP45.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP50.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "45",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP45.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP46.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP1.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "46",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP46.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP47.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP2.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "47",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP47.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP48.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP3.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "48",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP48.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP49.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP4.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "49",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP49.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP50.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP5.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },
    {
        code: "50",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងVIP',
        image: [
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP50.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP45.jpg`,
            `${BASE_URL}/soeungkhmerVIP/soeungkhmerVIP6.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងVIP"
    },

    // សុឹងខ្មែរ ជជើងចន្លោះ
    {
        code: "0001",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងចន្លោះ',
        image: [
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween1.jpg`,
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween6.jpg`,
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween9.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងចន្លោះ"
    },
    {
        code: "0002",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងចន្លោះ',
        image: [
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween2.jpg`,
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween7.jpg`,
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween10.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងចន្លោះ"
    },
    {
        code: "0003",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងចន្លោះ',
        image: [
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween3.jpg`,
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween8.jpg`,
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween11.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងចន្លោះ"
    },
    {
        code: "0004",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងចន្លោះ',
        image: [
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween4.jpg`,
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween9.jpg`,
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween12.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងចន្លោះ"
    },
    {
        code: "0005",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងចន្លោះ',
        image: [
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween5.jpg`,
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween10.jpg`,
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween13.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងចន្លោះ"
    },
    {
        code: "0006",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងចន្លោះ',
        image: [
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween6.jpg`,
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween11.jpg`,
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween14.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងចន្លោះ"
    },
    {
        code: "0007",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងចន្លោះ',
        image: [
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween7.jpg`,
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween12.jpg`,
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween15.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងចន្លោះ"
    },
    {
        code: "0008",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងចន្លោះ',
        image: [
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween8.jpg`,
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween13.jpg`,
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween16.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងចន្លោះ"
    },
    {
        code: "0009",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងចន្លោះ',
        image: [
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween9.jpg`,
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween14.jpg`,
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween1.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងចន្លោះ"
    },
    {
        code: "0010",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងចន្លោះ',
        image: [
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween10.jpg`,
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween15.jpg`,
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween2.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងចន្លោះ"
    },
    {
        code: "0011",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងចន្លោះ',
        image: [
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween11.jpg`,
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween16.jpg`,
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween3.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងចន្លោះ"
    },
    {
        code: "0012",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងចន្លោះ',
        image: [
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween12.jpg`,
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween1.jpg`,
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween4.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងចន្លោះ"
    },
    {
        code: "0013",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងចន្លោះ',
        image: [
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween13.jpg`,
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween2.jpg`,
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween5.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងចន្លោះ"
    },
    {
        code: "0014",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងចន្លោះ',
        image: [
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween14.jpg`,
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween3.jpg`,
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween6.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងចន្លោះ"
    },
    {
        code: "0015",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងចន្លោះ',
        image: [
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween15.jpg`,
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween4.jpg`,
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween7.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងចន្លោះ"
    },
    {
        code: "0016",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងចន្លោះ',
        image: [
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween16.jpg`,
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween5.jpg`,
            `${BASE_URL}/soeungkhmerbetween/soeungkhmerbetween8.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងចន្លោះ"
    },

    // សុឹងខ្មែរ បន្ដក់តូច
    {
        code: "0001",
        title: 'ក្រណាត់សុឹងខ្មែរ បន្ដក់តូច',
        image: [
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter1.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter6.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter9.jpg`,
        ],
        category: "សុឹងខ្មែរ បន្ដក់តូច"
    },
    {
        code: "0002",
        title: 'ក្រណាត់សុឹងខ្មែរ បន្ដក់តូច',
        image: [
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter2.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter7.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter10.jpg`,
        ],
        category: "សុឹងខ្មែរ បន្ដក់តូច"
    },
    {
        code: "0003",
        title: 'ក្រណាត់សុឹងខ្មែរ បន្ដក់តូច',
        image: [
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter3.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter8.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter11.jpg`,
        ],
        category: "សុឹងខ្មែរ បន្ដក់តូច"
    },
    {
        code: "0004",
        title: 'ក្រណាត់សុឹងខ្មែរ បន្ដក់តូច',
        image: [
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter4.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter9.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter12.jpg`,
        ],
        category: "សុឹងខ្មែរ បន្ដក់តូច"
    },
    {
        code: "0005",
        title: 'ក្រណាត់សុឹងខ្មែរ បន្ដក់តូច',
        image: [
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter5.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter10.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter13.jpg`,
        ],
        category: "សុឹងខ្មែរ បន្ដក់តូច"
    },
    {
        code: "0006",
        title: 'ក្រណាត់សុឹងខ្មែរ បន្ដក់តូច',
        image: [
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter6.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter11.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter14.jpg`,
        ],
        category: "សុឹងខ្មែរ បន្ដក់តូច"
    },
    {
        code: "0007",
        title: 'ក្រណាត់សុឹងខ្មែរ បន្ដក់តូច',
        image: [
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter7.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter12.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter15.jpg`,
        ],
        category: "សុឹងខ្មែរ បន្ដក់តូច"
    },
    {
        code: "0008",
        title: 'ក្រណាត់សុឹងខ្មែរ បន្ដក់តូច',
        image: [
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter8.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter13.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter16.jpg`,
        ],
        category: "សុឹងខ្មែរ បន្ដក់តូច"
    },
    {
        code: "0009",
        title: 'ក្រណាត់សុឹងខ្មែរ បន្ដក់តូច',
        image: [
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter9.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter14.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter17.jpg`,
        ],
        category: "សុឹងខ្មែរ បន្ដក់តូច"
    },
    {
        code: "0010",
        title: 'ក្រណាត់សុឹងខ្មែរ បន្ដក់តូច',
        image: [
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter10.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter15.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter18.jpg`,
        ],
        category: "សុឹងខ្មែរ បន្ដក់តូច"
    },
    {
        code: "0011",
        title: 'ក្រណាត់សុឹងខ្មែរ បន្ដក់តូច',
        image: [
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter11.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter16.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter19.jpg`,
        ],
        category: "សុឹងខ្មែរ បន្ដក់តូច"
    },
    {
        code: "0012",
        title: 'ក្រណាត់សុឹងខ្មែរ បន្ដក់តូច',
        image: [
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter12.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter17.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter20.jpg`,
        ],
        category: "សុឹងខ្មែរ បន្ដក់តូច"
    },
    {
        code: "0013",
        title: 'ក្រណាត់សុឹងខ្មែរ បន្ដក់តូច',
        image: [
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter13.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter18.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter21.jpg`,
        ],
        category: "សុឹងខ្មែរ បន្ដក់តូច"
    },
    {
        code: "0014",
        title: 'ក្រណាត់សុឹងខ្មែរ បន្ដក់តូច',
        image: [
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter14.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter19.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter1.jpg`,
        ],
        category: "សុឹងខ្មែរ បន្ដក់តូច"
    },
    {
        code: "0015",
        title: 'ក្រណាត់សុឹងខ្មែរ បន្ដក់តូច',
        image: [
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter15.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter20.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter2.jpg`,
        ],
        category: "សុឹងខ្មែរ បន្ដក់តូច"
    },
    {
        code: "0016",
        title: 'ក្រណាត់សុឹងខ្មែរ បន្ដក់តូច',
        image: [
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter16.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter21.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter3.jpg`,
        ],
        category: "សុឹងខ្មែរ បន្ដក់តូច"
    },
    {
        code: "0017",
        title: 'ក្រណាត់សុឹងខ្មែរ បន្ដក់តូច',
        image: [
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter17.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter1.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter4.jpg`,
        ],
        category: "សុឹងខ្មែរ បន្ដក់តូច"
    },
    {
        code: "0018",
        title: 'ក្រណាត់សុឹងខ្មែរ បន្ដក់តូច',
        image: [
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter18.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter2.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter5.jpg`,
        ],
        category: "សុឹងខ្មែរ បន្ដក់តូច"
    },
    {
        code: "0019",
        title: 'ក្រណាត់សុឹងខ្មែរ បន្ដក់តូច',
        image: [
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter19.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter3.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter6.jpg`,
        ],
        category: "សុឹងខ្មែរ បន្ដក់តូច"
    },
    {
        code: "0020",
        title: 'ក្រណាត់សុឹងខ្មែរ បន្ដក់តូច',
        image: [
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter20.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter4.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter7.jpg`,
        ],
        category: "សុឹងខ្មែរ បន្ដក់តូច"
    },
    {
        code: "0021",
        title: 'ក្រណាត់សុឹងខ្មែរ បន្ដក់តូច',
        image: [
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter21.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter5.jpg`,
            `${BASE_URL}/soeungkhmerlilter/soeungkhmerlilter8.jpg`,
        ],
        category: "សុឹងខ្មែរ បន្ដក់តូច"
    },

    // សុឹងខ្មែរ បន្ដក់ធំ
    {
        code: "0001",
        title: 'ក្រណាត់សុឹងខ្មែរ បន្ដក់ធំ',
        image: [
            `${BASE_URL}/soeungkhmerbig/soeungkhmerbig1.jpg`,
            `${BASE_URL}/soeungkhmerbig/soeungkhmerbig6.jpg`,
            `${BASE_URL}/soeungkhmerbig/soeungkhmerbig9.jpg`,
        ],
        category: "សុឹងខ្មែរ បន្ដក់ធំ"
    },
    {
        code: "0002",
        title: 'ក្រណាត់សុឹងខ្មែរ បន្ដក់ធំ',
        image: [
            `${BASE_URL}/soeungkhmerbig/soeungkhmerbig2.jpg`,
            `${BASE_URL}/soeungkhmerbig/soeungkhmerbig7.jpg`,
            `${BASE_URL}/soeungkhmerbig/soeungkhmerbig1.jpg`,
        ],
        category: "សុឹងខ្មែរ បន្ដក់ធំ"
    },
    {
        code: "0003",
        title: 'ក្រណាត់សុឹងខ្មែរ បន្ដក់ធំ',
        image: [
            `${BASE_URL}/soeungkhmerbig/soeungkhmerbig3.jpg`,
            `${BASE_URL}/soeungkhmerbig/soeungkhmerbig8.jpg`,
            `${BASE_URL}/soeungkhmerbig/soeungkhmerbig2.jpg`,
        ],
        category: "សុឹងខ្មែរ បន្ដក់ធំ"
    },
    {
        code: "0004",
        title: 'ក្រណាត់សុឹងខ្មែរ បន្ដក់ធំ',
        image: [
            `${BASE_URL}/soeungkhmerbig/soeungkhmerbig4.jpg`,
            `${BASE_URL}/soeungkhmerbig/soeungkhmerbig9.jpg`,
            `${BASE_URL}/soeungkhmerbig/soeungkhmerbig3.jpg`,
        ],
        category: "សុឹងខ្មែរ បន្ដក់ធំ"
    },
    {
        code: "0005",
        title: 'ក្រណាត់សុឹងខ្មែរ បន្ដក់ធំ',
        image: [
            `${BASE_URL}/soeungkhmerbig/soeungkhmerbig5.jpg`,
            `${BASE_URL}/soeungkhmerbig/soeungkhmerbig1.jpg`,
            `${BASE_URL}/soeungkhmerbig/soeungkhmerbig4.jpg`,
        ],
        category: "សុឹងខ្មែរ បន្ដក់ធំ"
    },
    {
        code: "0006",
        title: 'ក្រណាត់សុឹងខ្មែរ បន្ដក់ធំ',
        image: [
            `${BASE_URL}/soeungkhmerbig/soeungkhmerbig6.jpg`,
            `${BASE_URL}/soeungkhmerbig/soeungkhmerbig2.jpg`,
            `${BASE_URL}/soeungkhmerbig/soeungkhmerbig5.jpg`,
        ],
        category: "សុឹងខ្មែរ បន្ដក់ធំ"
    },
    {
        code: "0007",
        title: 'ក្រណាត់សុឹងខ្មែរ បន្ដក់ធំ',
        image: [
            `${BASE_URL}/soeungkhmerbig/soeungkhmerbig7.jpg`,
            `${BASE_URL}/soeungkhmerbig/soeungkhmerbig3.jpg`,
            `${BASE_URL}/soeungkhmerbig/soeungkhmerbig6.jpg`,
        ],
        category: "សុឹងខ្មែរ បន្ដក់ធំ"
    },
    {
        code: "0008",
        title: 'ក្រណាត់សុឹងខ្មែរ បន្ដក់ធំ',
        image: [
            `${BASE_URL}/soeungkhmerbig/soeungkhmerbig8.jpg`,
            `${BASE_URL}/soeungkhmerbig/soeungkhmerbig4.jpg`,
            `${BASE_URL}/soeungkhmerbig/soeungkhmerbig7.jpg`,
        ],
        category: "សុឹងខ្មែរ បន្ដក់ធំ"
    },
    {
        code: "0009",
        title: 'ក្រណាត់សុឹងខ្មែរ បន្ដក់ធំ',
        image: [
            `${BASE_URL}/soeungkhmerbig/soeungkhmerbig9.jpg`,
            `${BASE_URL}/soeungkhmerbig/soeungkhmerbig5.jpg`,
            `${BASE_URL}/soeungkhmerbig/soeungkhmerbig8.jpg`,
        ],
        category: "សុឹងខ្មែរ បន្ដក់ធំ"
    },

    // សុឹងខ្មែរ ជជើងឆ្កិះ
    {
        code: "0001",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងឆ្កិះ',
        image: [
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky1.jpg`,
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky6.jpg`,
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky9.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងឆ្កិះ",
    },
    {
        code: "0002",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងឆ្កិះ',
        image: [
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky2.jpg`,
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky7.jpg`,
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky10.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងឆ្កិះ",
    },
    {
        code: "0003",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងឆ្កិះ',
        image: [
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky3.jpg`,
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky8.jpg`,
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky11.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងឆ្កិះ",
    },
    {
        code: "0004",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងឆ្កិះ',
        image: [
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky4.jpg`,
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky9.jpg`,
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky12.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងឆ្កិះ",
    },
    {
        code: "0005",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងឆ្កិះ',
        image: [
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky5.jpg`,
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky10.jpg`,
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky13.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងឆ្កិះ",
    },
    {
        code: "0006",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងឆ្កិះ',
        image: [
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky6.jpg`,
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky11.jpg`,
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky14.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងឆ្កិះ",
    },
    {
        code: "0007",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងឆ្កិះ',
        image: [
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky7.jpg`,
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky12.jpg`,
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky1.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងឆ្កិះ",
    },
    {
        code: "0008",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងឆ្កិះ',
        image: [
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky8.jpg`,
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky13.jpg`,
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky2.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងឆ្កិះ",
    },
    {
        code: "0009",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងឆ្កិះ',
        image: [
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky9.jpg`,
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky14.jpg`,
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky3.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងឆ្កិះ",
    },
    {
        code: "0010",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងឆ្កិះ',
        image: [
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky10.jpg`,
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky1.jpg`,
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky4.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងឆ្កិះ",
    },
    {
        code: "0011",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងឆ្កិះ',
        image: [
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky11.jpg`,
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky2.jpg`,
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky5.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងឆ្កិះ",
    },
    {
        code: "0012",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងឆ្កិះ',
        image: [
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky12.jpg`,
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky3.jpg`,
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky6.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងឆ្កិះ",
    },
    {
        code: "0013",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងឆ្កិះ',
        image: [
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky13.jpg`,
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky4.jpg`,
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky7.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងឆ្កិះ",
    },
    {
        code: "0014",
        title: 'ក្រណាត់សុឹងខ្មែរ ជជើងឆ្កិះ',
        image: [
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky14.jpg`,
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky5.jpg`,
            `${BASE_URL}/soeungkhmersticky/soeungkhmersticky8.jpg`,
        ],
        category: "សុឹងខ្មែរ ជជើងឆ្កិះ",
    },

    // សុឹងខ្មែរ សាច់លាត
    {
        code: "0001",
        title: 'ក្រណាត់សុឹងខ្មែរ សាច់លាត',
        image: [
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat1.jpg`,
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat6.jpg`,
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat9.jpg`,
        ],
        category: "សុឹងខ្មែរ សាច់លាត",
    },
    {
        code: "0002",
        title: 'ក្រណាត់សុឹងខ្មែរ សាច់លាត',
        image: [
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat2.jpg`,
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat7.jpg`,
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat10.jpg`,
        ],
        category: "សុឹងខ្មែរ សាច់លាត",
    },
    {
        code: "0003",
        title: 'ក្រណាត់សុឹងខ្មែរ សាច់លាត',
        image: [
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat3.jpg`,
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat8.jpg`,
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat11.jpg`,
        ],
        category: "សុឹងខ្មែរ សាច់លាត",
    },
    {
        code: "0004",
        title: 'ក្រណាត់សុឹងខ្មែរ សាច់លាត',
        image: [
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat4.jpg`,
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat9.jpg`,
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat12.jpg`,
        ],
        category: "សុឹងខ្មែរ សាច់លាត",
    },
    {
        code: "0005",
        title: 'ក្រណាត់សុឹងខ្មែរ សាច់លាត',
        image: [
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat5.jpg`,
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat10.jpg`,
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat13.jpg`,
        ],
        category: "សុឹងខ្មែរ សាច់លាត",
    },
    {
        code: "0006",
        title: 'ក្រណាត់សុឹងខ្មែរ សាច់លាត',
        image: [
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat6.jpg`,
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat11.jpg`,
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat14.jpg`,
        ],
        category: "សុឹងខ្មែរ សាច់លាត",
    },
    {
        code: "0007",
        title: 'ក្រណាត់សុឹងខ្មែរ សាច់លាត',
        image: [
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat7.jpg`,
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat12.jpg`,
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat1.jpg`,
        ],
        category: "សុឹងខ្មែរ សាច់លាត",
    },
    {
        code: "0008",
        title: 'ក្រណាត់សុឹងខ្មែរ សាច់លាត',
        image: [
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat8.jpg`,
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat13.jpg`,
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat2.jpg`,
        ],
        category: "សុឹងខ្មែរ សាច់លាត",
    },
    {
        code: "0009",
        title: 'ក្រណាត់សុឹងខ្មែរ សាច់លាត',
        image: [
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat9.jpg`,
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat5.jpg`,
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat3.jpg`,
        ],
        category: "សុឹងខ្មែរ សាច់លាត",
    },
    {
        code: "0010",
        title: 'ក្រណាត់សុឹងខ្មែរ សាច់លាត',
        image: [
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat10.jpg`,
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat1.jpg`,
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat4.jpg`,
        ],
        category: "សុឹងខ្មែរ សាច់លាត",
    },
    {
        code: "0011",
        title: 'ក្រណាត់សុឹងខ្មែរ សាច់លាត',
        image: [
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat11.jpg`,
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat2.jpg`,
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat5.jpg`,
        ],
        category: "សុឹងខ្មែរ សាច់លាត",
    },
    {
        code: "0012",
        title: 'ក្រណាត់សុឹងខ្មែរ សាច់លាត',
        image: [
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat12.jpg`,
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat3.jpg`,
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat6.jpg`,
        ],
        category: "សុឹងខ្មែរ សាច់លាត",
    },
    {
        code: "0013",
        title: 'ក្រណាត់សុឹងខ្មែរ សាច់លាត',
        image: [
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat13.jpg`,
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat4.jpg`,
            `${BASE_URL}/soeugkhmersachleat/soeugkhmersachleat7.jpg`,
        ],
        category: "សុឹងខ្មែរ សាច់លាត",
    },

    // ក្រមាខ្មែរ អំបោះឆៅ  (ប៉ាក់ឈ្មោះ )
    {
        code: "0018",
        title: 'ក្រមាខ្មែរ អំបោះឆៅ  (ប៉ាក់ឈ្មោះ )',
        image: [
            `${BASE_URL}/soeungkhmerkansaeng/soeungkhmerkansaeng1.jpg`,
            `${BASE_URL}/soeungkhmerkansaeng/soeungkhmerkansaeng4.jpg`,
            `${BASE_URL}/soeungkhmerkansaeng/soeungkhmerkansaeng3.jpg`,
        ],
        category: "ក្រមាខ្មែរ អំបោះឆៅ",
    },
    {
        code: "0018",
        title: 'ក្រមាខ្មែរ អំបោះឆៅ  (ប៉ាក់ឈ្មោះ )',
        image: [
            `${BASE_URL}/soeungkhmerkansaeng/soeungkhmerkansaeng2.jpg`,
            `${BASE_URL}/soeungkhmerkansaeng/soeungkhmerkansaeng1.jpg`,
            `${BASE_URL}/soeungkhmerkansaeng/soeungkhmerkansaeng3.jpg`,
        ],
        category: "ក្រមាខ្មែរ អំបោះឆៅ",
    },
    {
        code: "0018",
        title: 'ក្រមាខ្មែរ អំបោះឆៅ  (ប៉ាក់ឈ្មោះ )',
        image: [
            `${BASE_URL}/soeungkhmerkansaeng/soeungkhmerkansaeng3.jpg`,
            `${BASE_URL}/soeungkhmerkansaeng/soeungkhmerkansaeng2.jpg`,
            `${BASE_URL}/soeungkhmerkansaeng/soeungkhmerkansaeng1.jpg`,
        ],
        category: "ក្រមាខ្មែរ អំបោះឆៅ",
    },
    {
        code: "0018",
        title: 'ក្រមាខ្មែរ អំបោះឆៅ  (ប៉ាក់ឈ្មោះ )',
        image: [
            `${BASE_URL}/soeungkhmerkansaeng/soeungkhmerkansaeng4.jpg`,
            `${BASE_URL}/soeungkhmerkansaeng/soeungkhmerkansaeng3.jpg`,
            `${BASE_URL}/soeungkhmerkansaeng/soeungkhmerkansaeng2.jpg`,
        ],
        category: "ក្រមាខ្មែរ អំបោះឆៅ",
    },

]
export const soeungHoleData = [
    {
        code: "0001",
        title: 'សុឹងហូល​​ខ្មែរ',
        image: [
            `${BASE_URL}/about-us/scarf.jpg`,
            `${BASE_URL}/space-between-legs/between-legs1.jpg`,
            `${BASE_URL}/space-between-legs/between-legs2.jpg`,
        ],
        category: "Soeung Hole",
        // originalPrice: "100.00",
        // salePrice: "90.00"
    },
    {
        code: "0002",
        title: 'សុឹងហូល​​ខ្មែរ',
        image: [
            `${BASE_URL}/about-us/scarf1.jpg`,
            `${BASE_URL}/space-between-legs/between-legs.jpg`,
            `${BASE_URL}/space-between-legs/between-legs1.jpg`,
        ],
        category: "Soeung Hole",
        // originalPrice: "100.00",
        // salePrice: "90.00"
    },
    {
        code: "0003",
        title: 'សុឹងហូល​​ខ្មែរ',
        image: [
            `${BASE_URL}/about-us/scarf2.jpg`,
            `${BASE_URL}/space-between-legs/between-legs2.jpg`,
            `${BASE_URL}/space-between-legs/between-legs.jpg`,
        ],
        category: "Soeung Hole",
        // originalPrice: "100.00",
        // salePrice: "90.00"
    },
    {
        code: "0004",
        title: 'សុឹងហូល​​ខ្មែរ',
        image: [
            `${BASE_URL}/about-us/scarf3.jpg`,
            `${BASE_URL}/space-between-legs/between-legs1.jpg`,
            `${BASE_URL}/space-between-legs/between-legs2.jpg`,
        ],
        category: "Soeung Hole",
        // originalPrice: "100.00",
        // salePrice: "90.00"
    },
    {
        code: "0005",
        title: 'សុឹងហូល​​ខ្មែរ',
        image: [
            `${BASE_URL}/about-us/scarf4.jpg`,
            `${BASE_URL}/space-between-legs/between-legs1.jpg`,
            `${BASE_URL}/space-between-legs/between-legs2.jpg`,
        ],
        category: "Soeung Hole",
        // originalPrice: "100.00",
        // salePrice: "90.00"
    },
]

export const soeungKontoisData = [
    {
        code: "0001",
        title: 'សុឹងហូល​​ខ្មែរ',
        image: [
            `${BASE_URL}/about-us/LongSleeve.jpg`,
            `${BASE_URL}/space-between-legs/between-legs1.jpg`,
            `${BASE_URL}/space-between-legs/between-legs2.jpg`,
        ],
        category: "Man Sleeve",
        // originalPrice: "100.00",
        // salePrice: "90.00"
    },
    {
        code: "0002",
        title: 'សុឹងហូល​​ខ្មែរ',
        image: [
            `${BASE_URL}/about-us/LongSleeve1.jpg`,
            `${BASE_URL}/space-between-legs/between-legs.jpg`,
            `${BASE_URL}/space-between-legs/between-legs1.jpg`,
        ],
        category: "Man Sleeve",
        // originalPrice: "100.00",
        // salePrice: "90.00"
    },
    {
        code: "0003",
        title: 'Man Sleeve',
        image: [
            `${BASE_URL}/about-us/LongSleeve2.jpg`,
            `${BASE_URL}/space-between-legs/between-legs2.jpg`,
            `${BASE_URL}/space-between-legs/between-legs.jpg`,
        ],
        category: "Man Sleeve",
        // originalPrice: "100.00",
        // salePrice: "90.00"
    },
    {
        code: "0004",
        title: 'Man Sleeve',
        image: [
            `${BASE_URL}/about-us/LongSleeve3.jpg`,
            `${BASE_URL}/space-between-legs/between-legs1.jpg`,
            `${BASE_URL}/space-between-legs/between-legs2.jpg`,
        ],
        category: "Man Sleeve",
        // originalPrice: "100.00",
        // salePrice: "90.00"
    },
    {
        code: "0005",
        title: 'Man Sleeve',
        image: [
            `${BASE_URL}/about-us/LongSleeve4.jpg`,
            `${BASE_URL}/space-between-legs/between-legs1.jpg`,
            `${BASE_URL}/space-between-legs/between-legs2.jpg`,
        ],
        category: "Man Sleeve",
        // originalPrice: "100.00",
        // salePrice: "90.00"
    },
    {
        code: "0006",
        title: 'សុឹងហូល​​ខ្មែរ',
        image: [
            `${BASE_URL}/about-us/Collection.jpg`,
            `${BASE_URL}/space-between-legs/between-legs1.jpg`,
            `${BASE_URL}/space-between-legs/between-legs2.jpg`,
        ],
        category: "Woman Sleeve",
        // originalPrice: "100.00",
        // salePrice: "90.00"
    },
    {
        code: "0007",
        title: 'សុឹងហូល​​ខ្មែរ VE',
        image: [
            `${BASE_URL}/about-us/Collection1.jpg`,
            `${BASE_URL}/space-between-legs/between-legs4.jpg`,
            `${BASE_URL}/space-between-legs/between-legs5.jpg`,
        ],
        category: "Woman Sleeve",
        // originalPrice: "100.00",
        // salePrice: "100.00"
    },
    {
        code: "0008",
        title: 'សុឹងហូល​​ខ្មែរ VE',
        image: [
            `${BASE_URL}/about-us/Collection2.jpg`,
            `${BASE_URL}/space-between-legs/between-legs4.jpg`,
            `${BASE_URL}/space-between-legs/between-legs5.jpg`,
        ],
        category: "Woman Sleeve",
        // originalPrice: "100.00",
        // salePrice: "100.00"
    },
    {
        code: "0009",
        title: 'សុឹងហូល​​ខ្មែរ VE',
        image: [
            `${BASE_URL}/about-us/Collection3.jpg`,
            `${BASE_URL}/space-between-legs/between-legs4.jpg`,
            `${BASE_URL}/space-between-legs/between-legs5.jpg`,
        ],
        category: "Woman Sleeve",
        // originalPrice: "100.00",
        // salePrice: "100.00"
    },
    {
        code: "0010",
        title: 'សុឹងហូល​​ខ្មែរ VE',
        image: [
            `${BASE_URL}/about-us/Collection4.jpg`,
            `${BASE_URL}/space-between-legs/between-legs4.jpg`,
            `${BASE_URL}/space-between-legs/between-legs5.jpg`,
        ],
        category: "Woman Sleeve",
        // originalPrice: "100.00",
        // salePrice: "100.00"
    },
]

export const kontoisData = [
    {
        code: "0001",
        title: 'សុឹងហូល​​ខ្មែរ',
        image: [
            `${BASE_URL}/about-us/bestSeller.jpg`,
            `${BASE_URL}/space-between-legs/between-legs1.jpg`,
            `${BASE_URL}/space-between-legs/between-legs2.jpg`,
        ],
        category: "Man Sleeve",
        // originalPrice: "100.00",
        // salePrice: "90.00"
    },
    {
        code: "0002",
        title: 'សុឹងហូល​​ខ្មែរ',
        image: [
            `${BASE_URL}/about-us/bestSeller1.jpg`,
            `${BASE_URL}/space-between-legs/between-legs.jpg`,
            `${BASE_URL}/space-between-legs/between-legs1.jpg`,
        ],
        category: "Man Sleeve",
        // originalPrice: "100.00",
        // salePrice: "90.00"
    },
    {
        code: "0003",
        title: 'Man Sleeve',
        image: [
            `${BASE_URL}/about-us/bestSeller2.jpg`,
            `${BASE_URL}/space-between-legs/between-legs2.jpg`,
            `${BASE_URL}/space-between-legs/between-legs.jpg`,
        ],
        category: "Man Sleeve",
        // originalPrice: "100.00",
        // salePrice: "90.00"
    },
    {
        code: "0004",
        title: 'Man Sleeve',
        image: [
            `${BASE_URL}/about-us/bestSeller3.jpg`,
            `${BASE_URL}/space-between-legs/between-legs1.jpg`,
            `${BASE_URL}/space-between-legs/between-legs2.jpg`,
        ],
        category: "Man Sleeve",
        // originalPrice: "100.00",
        // salePrice: "90.00"
    }
]

export const relatedData = [
    {
        code: "0001",
        title: 'សុឹងហូល​​ខ្មែរ',
        image: [
            `${BASE_URL}/about-us/soeungKontoisKaneav.jpg`,
            `${BASE_URL}/space-between-legs/between-legs1.jpg`,
            `${BASE_URL}/space-between-legs/between-legs2.jpg`,
        ],
        category: "Man Sleeve",
        // originalPrice: "100.00",
        // salePrice: "90.00"
    },
    {
        code: "0002",
        title: 'សុឹងហូល​​ខ្មែរ',
        image: [
            `${BASE_URL}/about-us/soeungKontoisKaneav1.jpg`,
            `${BASE_URL}/space-between-legs/between-legs.jpg`,
            `${BASE_URL}/space-between-legs/between-legs1.jpg`,
        ],
        category: "Man Sleeve",
        // originalPrice: "100.00",
        // salePrice: "90.00"
    },
    {
        code: "0003",
        title: 'Man Sleeve',
        image: [
            `${BASE_URL}/about-us/soeungKontoisKaneav2.jpg`,
            `${BASE_URL}/space-between-legs/between-legs2.jpg`,
            `${BASE_URL}/space-between-legs/between-legs.jpg`,
        ],
        category: "Man Sleeve",
        // originalPrice: "100.00",
        // salePrice: "90.00"
    },
    {
        code: "0004",
        title: 'Man Sleeve',
        image: [
            `${BASE_URL}/about-us/soeungKontoisKaneav3.jpg`,
            `${BASE_URL}/space-between-legs/between-legs1.jpg`,
            `${BASE_URL}/space-between-legs/between-legs2.jpg`,
        ],
        category: "Man Sleeve",
        // originalPrice: "100.00",
        // salePrice: "90.00"
    }
]